import React from 'react';
import { motion } from 'framer-motion';
import { FiMapPin } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import heroImage from '../images/hero.jpg';
import { SQUARE_SERVICES_URL } from '../constants/links';
import { useLanguage } from '../i18n/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-brand-sand">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="z-10 text-center md:text-left"
        >
          <div className="inline-flex items-center gap-2 text-brand-muted text-sm uppercase tracking-widest mb-6">
            <SafeIcon icon={FiMapPin} className="w-4 h-4 text-brand-taupe" />
            <span>{t('hero.locationPill')}</span>
          </div>
          
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-dark leading-tight mb-6 text-balance">
            {t('hero.title')}
          </h1>
          
          <p className="text-brand-muted text-lg md:text-xl mb-10 max-w-lg mx-auto md:mx-0 font-light leading-relaxed">
            {t('hero.subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a 
              href={SQUARE_SERVICES_URL}
              target="_blank"
              rel="noreferrer"
              className="bg-brand-taupe hover:bg-brand-taupeDark text-white px-8 py-4 rounded-full text-center font-medium transition-all shadow-md hover:shadow-lg"
            >
              {t('nav.bookAppointment')}
            </a>
            <a 
              href="#services" 
              className="bg-white hover:bg-gray-50 text-brand-dark px-8 py-4 rounded-full text-center font-medium transition-all shadow-sm border border-brand-sand"
            >
              {t('hero.viewServices')}
            </a>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="relative h-[400px] md:h-[600px] rounded-2xl overflow-hidden shadow-2xl"
        >
          <img 
            src={heroImage} 
            alt={t('hero.imageAlt')}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/20 to-transparent"></div>
        </motion.div>

      </div>
    </section>
  );
};

export default Hero;
